export default __webpack_public_path__ + "static/media/advanced.712611c7.jpg";